const CBookingRunningStatus = {
  NOT_RUN: "yetToRun",
  STARTING_SOON: "startingSoon",
  RUNNING: "running",
  FINISHED: "finished"
};

export default CBookingRunningStatus;
